/** Filipino: Workflows P6 (M26, DEC-099): ang seksyong Default workflows, ang mga dialog ng pause / restore / duplicate at ang builder ng isang default. Isinasama sa `engage.workflows`. */
export const workflowsDefaults = {
  title: "Mga default na workflow",
  intro: "Tumatakbo ang mga ito para sa lahat sa inyong workspace sa bawat plano at hindi binibilang sa inyong mga limitasyon. Baguhin ang mga ito para mapalitan kung sino ang aabisuhan; i-pause ang isa para ihinto ito.",
  own: {
    title: "Mga workflow ninyo",
    subtitle: "Mga workflow na kayo ang gumawa. Tumatakbo ang mga ito pagkatapos ng mga default.",
  },
  areas: {
    conversations: "Mga usapan at handoff",
    leads: "Leads at bookings",
    knowledge: "Knowledge",
    developers: "Mga developer",
    service_desk: "Service desk",
  },
  badge: "Default",
  modified: "Binago",
  updateAvailable: "May update",
  offByDefault: "Naka-off bilang default",
  runs_one: "{{count}} run sa nakaraang 30 araw",
  runs_other: "{{count}} run sa nakaraang 30 araw",
  switchOn: "I-on",
  switchOnLabel: "I-on ang {{name}}",
  switchedOn: "Naka-on na ang {{name}}",
  paused: "Naka-pause ang {{name}}",
  resumed: "Live na ulit ang {{name}}",
  kpiDefaults: "+{{count}} default",
  kpiRunsHint: "Kasama sa mga run at pumalyang run ang mga default na workflow.",
  kpiLabel: "Buod ng workflow, nakaraang 30 araw",
  banner: {
    title_one: "{{count}} default na workflow ang naka-pause",
    title_other: "{{count}} default na workflow ang naka-pause",
    resume: "Ituloy",
    resumeLabel: "Ituloy ang {{name}}",
  },
  menu: {
    label: "Mga aksyon para sa {{name}}",
    open: "Buksan",
    pause: "I-pause",
    resume: "Ituloy",
    duplicate: "I-duplicate",
    restore: "Ibalik ang default",
    restoreDisabled: "Ibalik ang default (walang binago)",
    compare: "Ihambing sa default",
  },
  pause: {
    title: "I-pause ang “{{name}}”?",
    stops: "Ititigil nito ang:",
    window: "Mula sa nakaraang {{days}} araw ang mga bilang.",
    nothing: "Sa nakaraang {{days}} araw, wala itong ipinadala o itinalaga, kaya walang magbabago na mapapansin ninyo kapag ipinause ito.",
    people_one: "{{count}} tao",
    people_other: "{{count}} tao",
    alerts_one: "{{count}} alerto sa {{people}}",
    alerts_other: "{{count}} alerto sa {{people}}",
    mailboxes_one: "{{count}} e-mail sa shared mailbox",
    mailboxes_other: "{{count}} e-mail sa mga shared mailbox",
    deliveries_one: "{{count}} delivery sa mga webhook endpoint ninyo",
    deliveries_other: "{{count}} delivery sa mga webhook endpoint ninyo",
    assignments_one: "{{count}} usapan o lead na itinalaga sa isang tao",
    assignments_other: "{{count}} usapan o lead na itinalaga sa mga tao",
    loading: "Binibilang ang ginawa nito sa nakaraang 30 araw",
    impactFailed: "Hindi namin ma-load ang mga bilang. Maaari pa rin ninyo itong i-pause.",
    memberSettings: "Hindi na maibabalik ng notification settings ng mga miyembro ang mga ito.",
    endpointsKeep: "Nananatili ang mga subscription ng mga endpoint ninyo. Wala silang matatanggap hangga't hindi ninyo itinutuloy ang workflow na ito.",
    confirmAlerts: "I-pause at ihinto ang mga alertong ito",
    confirmDeliveries: "I-pause at ihinto ang mga delivery na ito",
  },
  restore: {
    title: "Ibalik ang “{{name}}”?",
    body: "Ibabalik nito ang orihinal na default kapalit ng mga pagbabago ninyo. Mananatili sa version history ang kasalukuyang bersyon.",
    bodyUpdate: "Piliin kung aling default ang ibabalik.",
    target: "Ibalik sa",
    targetBaseline: "Ang default na pinagsimulan ninyo",
    targetBaselineHint: "Ibinabalik ang mga hakbang at settings na ibinigay sa workflow na ito.",
    targetLatestPlain: "Ang pinakabagong default",
    targetLatest: "Ang pinakabagong default (rebisyon {{revision}})",
    targetLatestHint: "Lilipat ang workflow sa pinakabagong wika at mga hakbang, at ang pinakabagong default na ang babalikan ng Ibalik ang default. Palaging ipinapublish ito.",
    publish: "I-publish ngayon",
    publishHint: "I-off ito para draft lang ang mapalitan, para matingnan muna ninyo. Hindi magbabago kung tumatakbo ang workflow.",
    publishLatest: "Palaging ipinapublish ang pinakabagong default.",
    unpublished: "May mga pagbabago ang workflow na ito na hindi pa na-publish. Papalitan ng pagbabalik ang mga iyon.",
    unsaved: "May mga edit kayong hindi pa na-save. Papalitan ng pagbabalik ang mga iyon.",
    changes: "Ano ang magbabago",
    nothing: "Kapareho na ng default ang workflow na ito.",
    yours: "Bersyon ninyo",
    original: "Default",
    confirmPublish: "Ibalik at i-publish",
    confirmDraft: "Ibalik sa draft",
    confirmLatest: "I-update at i-publish",
    restored: "Naibalik. Live na ang bersyon {{version}}.",
    restoredDraft: "Naibalik sa draft. I-publish kapag handa na kayo.",
    updated: "Na-update sa pinakabagong default. Live na ang bersyon {{version}}.",
    wasPaused: "Mananatili itong naka-pause hanggang ituloy ninyo.",
  },
  compare: {
    title: "Ihambing sa default",
    hint: "Ang mga hakbang ng workflow na ito katabi ng default na pinagsimulan nito.",
    baseline: "Default",
    modifiedNote: "Iba ang bersyon ninyo sa default.",
  },
  duplicate: {
    title: "I-duplicate ang “{{name}}”",
    body: "Magkakaroon kayo ng sariling workflow na malaya ninyong mababago. Patuloy na tatakbo ang default. I-pause ito kung papalitan ito ng kopya ninyo, kung hindi ay parehong magpapadala.",
    swapped: "Ang mga hakbang na default workflow lang ang puwedeng gumamit ay pinapalitan o inaalis, at sasabihin ng draft kung alin.",
    name: "Pangalan ng kopya",
    copyName: "Kopya ng {{name}}",
    confirm: "Gawin ang kopya",
    created: "Nagawa ang kopya bilang draft",
  },
  upgrade: {
    title: "Gumawa ng sarili ninyong workflow sa Standard",
    body: "Sakop na ng mga default na workflow sa itaas ang mga alerto, pag-assign at webhook event ninyo sa bawat plano. Sa Standard, makakagawa rin kayo ng sarili ninyong workflow: welcome menu, lead rules, follow-up at iba pa.",
    cta: "Tingnan ang mga plano",
    sheetTitle: "Nasa Standard ang sariling workflow",
    sheetBody: "Kailangan ng planong Standard o mas mataas para gumawa ng workflow, magsimula sa template o mag-duplicate ng default. Patuloy na tatakbo ang mga default na workflow at mababago at mapa-pause pa rin ninyo ang mga ito.",
    sheetClose: "Hindi muna",
    lock: "Kailangan ang planong {{plan}}",
    locked: "Naka-lock sa plano ninyo",
  },
  builder: {
    bannerTitle: "Default na workflow",
    banner: "Tumatakbo ito sa bawat plano at hindi binibilang sa run limit ninyo. Maaari ninyong baguhin ang mga hakbang nito, i-pause ito o ibalik ang orihinal anumang oras.",
    bannerStarter: "Sa plano ninyo, mababago at mapa-pause ninyo ito. Kailangan ng planong Standard para i-duplicate ito.",
    bannerModified: "Binago ninyo ang workflow na ito. Ibabalik ng Ibalik ang default ang orihinal.",
    bannerUpdate: "May mas bagong default. Hinahayaan kayo ng Ibalik ang default na mag-update dito.",
    restore: "Ibalik ang default",
    compare: "Ihambing sa default",
    duplicate: "I-duplicate",
    triggerLocked: "Hindi mapapalitan ang trigger ng default na workflow. I-duplicate ito para magsimula sa ibang trigger.",
    triggerLockedBadge: "Naka-lock",
    deleteReason: "Hindi mabubura ang mga default na workflow. I-pause na lang ito.",
    pausedNote: "Naka-pause ang workflow na ito. {{impact}}",
    lockedStep: "Hindi magagamit sa mga default na workflow: i-duplicate para magamit",
    lockedStepPicked: "Hindi magagamit ng mga default na workflow ang {{step}}. I-duplicate ang workflow na ito para magamit ito.",
    lockedStepPickedStarter: "Hindi magagamit ng mga default na workflow ang {{step}}. Kailangan ng planong Standard para mag-duplicate ng workflow.",
    onlyUnder: "Sa workflow na “{{trigger}}” lang",
    limits: "Hanggang {{paths}} path at {{steps}} hakbang sa isang path ang default na workflow.",
    addStepHint: "Gumagamit ang mga default na workflow ng alerto, routing, tag, tala, priority at kondisyon. Nasa listahan ang ibang hakbang pero naka-lock.",
    notInDefaults: "wala sa mga default na workflow",
    restoredToast: "Naibalik",
  },
  events: {
    title: "Mga event na ipinapadala nito",
    all: "Lahat ng event na sinusubaybayan ng mga endpoint ninyo",
    only: "Ang mga event na ito lang",
    mode: "Aling mga event",
    subscribed: "Kasalukuyang sinusubaybayan ng mga endpoint ninyo:",
    none: "Wala pang endpoint na sumusubaybay sa event. Magdagdag sa Settings → Webhooks.",
    noAccess: "Kailangan ninyo ng pahintulot na mamahala ng webhooks para makita kung anong mga event ang sinusubaybayan ng mga endpoint ninyo.",
    loadFailed: "Hindi namin ma-load ang mga endpoint ninyo.",
    required: "Pumili ng kahit isang event, o ipadala ang lahat ng event.",
    hint: "Ang bawat endpoint pa rin ang pumipili ng sarili nitong mga event sa Settings → Webhooks. Paliliitin lang ng setting na ito ang ipinapadala ng workflow na ito.",
    link: "Buksan ang webhook settings",
  },
  cross: {
    names: {
      handoff_route_and_alert: "I-route at i-alerto ang mga bagong handoff",
      new_lead_route_and_alert: "Magtalaga ng owner at ianunsyo ang mga bagong lead",
      developer_webhooks: "Ipadala ang mga event sa inyong webhook endpoints",
    },
    open: "Buksan ang workflow",
    paused: "Naka-pause ang “{{name}}”. {{impact}}",
    handoffSettings: "Ginagamit ng default na workflow na “{{name}}” ang mga setting na ito.",
    leadsRouting: "Ginagamit ng default na workflow na “{{name}}” ang patakarang ito.",
    notifications: "Sa Workflows → Mga default na workflow itinatakda kung aling mga event ang nag-aabiso sa team ninyo. Dito ninyo pinipili kung paano ninyo ito matatanggap.",
    notificationsLink: "Buksan ang mga default na workflow",
    routedBy: "Na-route ng",
    routedByDefault: "Isang default na workflow",
  },
  standard: {
    title: "Karaniwang mensahe",
    body: "Nakukuha ng mga tao ang parehong wika na nakasanayan nila. Narito ang halimbawa.",
    preview: "Halimbawa",
    writeOwn: "Sumulat ng sarili ko",
    writeOwnHint: "Lilipat sa mensaheng kayo ang susulat. Magsisimula ito sa teksto ng halimbawa.",
    custom: "Sarili ninyong mensahe",
    useStandard: "Gamitin ang karaniwang mensahe",
    noStandard: "Walang karaniwang mensahe ang workflow na ito. Sumulat ng sarili ninyo.",
    samples: {
      handoff_requested: { title: "Humingi ng tao si Maria Cruz", body: "Admissions Assistant · Gustong makipag-usap tungkol sa tuition" },
      handoff_reminder_due: { title: "5 minuto nang naghihintay ng sagot si Maria Cruz", body: "Admissions Assistant · Gustong makipag-usap tungkol sa tuition" },
      handoff_escalation_due: { title: "Naghihintay pa rin si Maria Cruz makalipas ang 15 minuto", body: "Admissions Assistant · Gustong makipag-usap tungkol sa tuition" },
      handoff_waiting_digest_due: { title: "3 bisita ang naghihintay sa inyo", body: "Humingi ng tao ang mga bisita habang sarado ang opisina." },
      conversation_assigned: { title: "Itinalaga sa inyo si Maria Cruz", body: "Admissions Assistant · Gustong makipag-usap tungkol sa tuition" },
      conversation_returned_to_queue: { title: "Bumalik si Maria Cruz sa queue ng Admissions", body: "Admissions Assistant · Gustong makipag-usap tungkol sa tuition" },
      lead_created: { title: "Bagong lead mula sa Admissions Assistant", body: "Nagtanong si Maria Cruz tungkol sa enrolment sa Grade 7." },
      lead_followed_up: { title: "Bagong kahilingan mula kay Maria Cruz", body: "Nagtatanong kung may slot pa sa Sabado." },
      lead_updated: { title: "May lead na itinalaga sa inyo", body: "Maria Cruz" },
      booking_requested: { title: "Hiniling ang appointment: Maria Cruz", body: "Campus tour - Sab, Nob 7, 10:00 AM" },
      booking_confirmed: { title: "Na-book ang appointment: Maria Cruz", body: "Campus tour - Sab, Nob 7, 10:00 AM" },
      source_processed: { title: "Handa na ang “Admissions handbook”", body: "Makakasagot na ang assistant mula sa source na ito." },
      source_failed: { title: "Hindi naproseso ang “Admissions handbook”", body: "Pumalya ang pagproseso. Mag-upload ng bagong kopya o makipag-ugnayan sa support." },
      gap_assigned: { title: "May knowledge gap na itinalaga sa inyo", body: "Ano ang mga deadline ng scholarship?" },
    },
  },
};
